import React, {ReactNode} from 'react';
import {questionBonusStyles} from '../styles';

interface SectionProps {
  title: string;
  children: ReactNode;
}

export const Section = ({title, children}: SectionProps) => (
  <section style={questionBonusStyles.section}>
    <h2 style={questionBonusStyles.sectionTitle}>{title}</h2>
    {children}
  </section>
);

export default Section;



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/QuestionBonus/components/Section.tsx